define(function (require) {
    "use strict";

    var LEConfig = require("assets/config/le-env-conf");
    // var PersonalizationMainLayout = require("personalization-views/PersonalizationMainLayout");
    var PersonalizationModel = require("personalization-models/PersonalizationModel");
    var PersonalizationWidgetController = require("personalization-controllers/PersonalizationWidgetController");
    var PersonalizationNavigationController = require("personalization-controllers/PersonalizationNavigationController");
    var PersonalizationModuleLayout = require("personalization-views/PersonalizationModuleLayout");
    //var MenuView = require("personalization-views/MenuView");

    var PersonalizationController = {};

    LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        PersonalizationController = Marionette.Controller.extend({
            initialize: function (options) {
                this.personalizationModel = new PersonalizationModel();
                LEPersonalization.personalizationModel= this.personalizationModel;
                this.personalizationNavigationController = new PersonalizationNavigationController({
                    personalizationModel: this.personalizationModel
                });
//                //add personalization button to top bar only if the user has any NV features.
                if (this.personalizationNavigationController.getNumberOfFeatures() > 0) {
                    LE.on("start", function (options) {
                        this._setRouteChangesListener();
                        this._setCurrentPage();
                        this.personalizationWidgetController = new PersonalizationWidgetController({
                            personalizationModel: this.personalizationModel
                        });
                    }, this);
                }

                this.personalizationModuleLayout = new PersonalizationModuleLayout({
                    model: this.personalizationModel
                });

                //listen to route changes


            },
            getMainView: function () {
                return this.personalizationModuleLayout;
            },
            navigateToPageMenu: function (options) {
                return this.personalizationNavigationController.navigateToPageMenu(options);
            },

            navigateToFeatureEdit: function (options) {
                return this.personalizationNavigationController.navigateToFeatureEdit(options);
            },
            getFeaturesByRoutCount: function (options) {
                return this.personalizationNavigationController.getFeaturesByRoutCount(options);
            },

            setLoader: function () {
                return  this.personalizationModuleLayout.setLoader();
            },
            closeLoader: function () {
                return  this.personalizationModuleLayout.closeLoader();
            },
            _setRouteChangesListener: function () {
                this.listenTo(LE.context, "change:navigationCurrent.route", function (model, route) {
                    var page = this._getPageNameByRoute(route);
                    this.personalizationModel.set("page", page);
                });

                this.listenTo(LE.context, "change:LEWebAgent.page", function (model, page) {
                    if (LE.context.get("activeModuleName") === "LEWebAgent") {
                        this.personalizationModel.set("page", page);
                    }
                });

                this.listenTo(LE.context, "change:activeModuleName", function (model, activeModuleName) {
                    if (activeModuleName === "LEWebAgent") {
                        this.personalizationModel.set("page", LE.context.get("LEWebAgent.page"));
                    } else {
                        var page = this._getPageNameByRoute(LE.context.get("navigationCurrent.route"));
                        //The event is thrown again since featuresCount was previously calculated for incorrect module and correct page.
                        this.personalizationModel.trigger("change:page", page);
                    }
                    this.personalizationModel.set("module", activeModuleName);
                    this.personalizationModel.set("isOpen", false);

                });
                this.listenTo(LE.context, "change:LEReporting.isOpened", function (model, isOpened) {
                    this.personalizationModel.set("isReportingOpen", isOpened);
                });
            },
            _getPageNameByRoute: function (route) {
                var pageName;
                var activeRouter = LE.navigator.getActiveRouter();
                if (activeRouter && activeRouter.controller.getActivePageName) {
                    pageName = activeRouter.controller.getActivePageName(route);
                }
                return pageName;
            },
            _setCurrentPage: function () {
                var activeModuleName = LE.context.get("activeModuleName");
                var page;
                if (activeModuleName === "LEWebAgent") {
                    page = LE.context.get("LEWebAgent.page");
                }
                else {
                    var route = LE.context.get("navigationCurrent.route");
                     page = this._getPageNameByRoute(route);
                }
                this.personalizationModel.set("page", page);
            }

        });
    });
    return PersonalizationController;
});
